import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { VideoComponent } from './video/video.component';
import { DocumentComponent } from './document/document.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageHeaderComponent } from './shared/page-header/page-header.component';
import { MastersComponent } from './masters/masters.component';
import { DevGuard } from './guards/dev.guard';
import { UploadComponent } from './upload/upload.component';
import { LoginpageComponent } from './loginpage/loginpage.component';
import { OverviewComponent } from './overview/overview.component';
import { FaqComponent } from './faq/faq.component';
import { UsersSyncComponent } from '../users-sync/users-sync.component';

export const routes: Routes = [
      // { path: 'coming-soon', component: ComingSoonComponent },
    // { path: '', component: AppComponent},
    { path: 'login', component: LoginpageComponent },
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' }, // Default route
    { path: 'dashboard', component: DashboardComponent, canActivate: [DevGuard],},
    { path: 'masters', component: MastersComponent, canActivate: [DevGuard]},
    { path: 'content', component: PageHeaderComponent,canActivate: [DevGuard] }, // Main content route
    { path: 'content/:module', component: PageHeaderComponent,canActivate: [DevGuard],
      children: [ 
         { path: '', redirectTo: 'overview', pathMatch: 'full' },
          { path: 'overview', component: OverviewComponent },
          { path: 'videos', component: VideoComponent },
          { path: 'video/:id', component: VideoComponent },
          { path: 'documents', component: DocumentComponent },
          { path: 'document/:id', component: DocumentComponent },
          { path: 'faq', component: FaqComponent },
       ]
    },
    { path: 'upload', component: UploadComponent,canActivate: [DevGuard] },
    { path: 'users-sync', component: UsersSyncComponent, canActivate: [DevGuard] },
    // { path: 'video', component: VideoComponent},
    // { path: 'document', component: DocumentComponent},
    // { path: '**', redirectTo: '', pathMatch: 'full' }, // Wildcard route to redirect invalid routes to root

    { path: '**', redirectTo: '/dashboard' },
];
